import { FC } from "react";

import s from "./select.module.scss";

interface SelectProps {
  label: string;
  name: string;
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  options: {
    label: string;
    value: string;
  }[];
}

export const Select: FC<SelectProps> = ({ label, name, onChange, options }) => (
  <div className={s.Wrapper}>
    <label htmlFor={name} className={s.Label}>
      {label}
    </label>
    <select id={name} name={name} onChange={onChange} className={s.Select}>
      {options.map((option, index) => (
        <option key={index} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  </div>
);
